import { axiosRequestGET, axiosRequestPUT } from './serviceConfig';

export const getOpenRolesService = () => axiosRequestGET('/api/editor/designboard');

export const showRoleService = (id, spaceId) => axiosRequestPUT('/api/editor/designboard/show-role', { id, spaceId });

export const hideRoleService = (id, spaceId) => axiosRequestPUT('/api/editor/designboard/hide-role', { id, spaceId });

export const hideAllRolesService = (spaceId) => axiosRequestPUT('/api/editor/designboard/hide-all-roles', { spaceId });
